import { render, staticRenderFns } from "./KhVueSolo.vue?vue&type=template&id=18478a5e"
import script from "./KhVueSolo.ts?vue&type=script&lang=ts&external"
export * from "./KhVueSolo.ts?vue&type=script&lang=ts&external"
import style0 from "./KhVueSolo.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports